import { ACTIONS } from 'constants/annotations';
import { ANNOTATION_EVENT, PLAYER_CONTROL_EVENT } from 'constants/events';

export const expandable = Annotation => class extends Annotation {
    constructor(props) {
        super(props);
        this.state.playerAnnotationExpanded = props.target ==='player' && props.properties && props.properties.startExpanded || false
        this.syntheticExpandHandler = this.synthesizeActionHandler(ACTIONS.EXPAND_TARGET);
        this.syntheticCollapseHandler = this.synthesizeActionHandler(ACTIONS.COLLAPSE_TARGET);
    }

    onExpand = e => {
        const { eventBus, props, syntheticExpandHandler } = this,
            { expanded } = this.props?.parentState || {};
            
        if (expanded) {
            return;
        }

        e.stopPropagation();
        eventBus.emit(ANNOTATION_EVENT.EXPAND_TARGET, props.target);
        eventBus.emit(ANNOTATION_EVENT.ANNOTATION_ACTION, 'Click', { ...props }, syntheticExpandHandler);
    }

    onCollapse = e => {
        const { eventBus, props, syntheticCollapseHandler } = this,
            { expanded } = this.props?.parentState || {};
        
        if (!expanded) {
            return;
        }

        e.stopPropagation();
        eventBus.emit(ANNOTATION_EVENT.CONTRACT_TARGET, props.target);
        eventBus.emit(ANNOTATION_EVENT.ANNOTATION_ACTION, 'Click', { ...props }, syntheticCollapseHandler);
    }

    onExpandPlayerAnnotation = () => {
        const { eventBus } = this;

        this.setState({
            playerAnnotationExpanded: true
        })

        eventBus && eventBus.emit(PLAYER_CONTROL_EVENT.PAUSE)
    }

    onCollapsePlayerAnnotation = () => {
        const { eventBus } = this;

        this.setState({
            playerAnnotationExpanded: false
        })
        
        eventBus && eventBus.emit(PLAYER_CONTROL_EVENT.PLAY)
    }

    getElementStyles = (selector) => {
        if (selector) {
            return super.getElementStyles(selector);
        }

        const { playerAnnotationExpanded } = this.state;

        if (!playerAnnotationExpanded) {
            return super.getElementStyles();
        } else { 
            return {
                ...super.getElementStyles(),
                height: "100%",
                width: "100%",
                top: "0%",
                left: "0%",
                zIndex: "2"
            }
            
        }
    }

    // We need to express the expand/collapse instructions as annotation actions
    // for consumption by analytics event generators (see AnnotationTracker.getAnnotationActionEventResponses)
    synthesizeActionHandler(action, args = {}) {
        return [{ action, args }];
    }

    get classes() {
        const { showExpanded = false } = this.options;

        if (!showExpanded) {
            return super.classes
        }
        
        return [
            ...super.classes,
            ' expandable-overlay'
        ]
    }

    get dataAttrs() {
        const { showExpanded = false, animate = false, } = this.options;

        return {
            ...super.dataAttrs,
            ...( showExpanded ? {
                "data-expanded": this.state.playerAnnotationExpanded || false,
                "data-animate": animate
        } : {})
        }
    }

    get controlBarStyles() {
        const { expanded } = this.props?.parentState || {};

        return Object.keys(this.props.styles || {}).filter(k => k.includes('controlBar')).reduce((collected, key, index, keys) => {
            const abbreviatedID = key.substring(key.indexOf('controlBar')),
                isRootStyle = key.endsWith('controlBar'),
                applyExpanded = expanded && abbreviatedID === 'controlBar.expanded';

            collected[abbreviatedID] = { ...this.props.styles[key] };

            if (isRootStyle) {
                if (!expanded) {
                    collected[abbreviatedID].backgroundColor = 'transparent';
                    collected[abbreviatedID].border = 'none';
                } else {
                    collected[abbreviatedID].backgroundColor = collected[abbreviatedID].backgroundColor || 'transparent';
                    collected[abbreviatedID].border = collected[abbreviatedID].border || 'none';
                }
                
            }

            if (applyExpanded) {
                collected['controlBar'] = collected[abbreviatedID];
            }

            return collected;
        }, {});
    }

    static get expandable() {
        return true;
    }
}